import { create } from 'zustand';
import Cookies from "js-cookie";

export const useAuthStore = create((set) => ({
    accessToken: Cookies.get("accessToken") || null,
    refreshToken: Cookies.get("refreshToken") || null,
    role: Cookies.get("role") || null,
    user: Cookies.get("user") ? JSON.parse(Cookies.get("user")) : null,

    setTokens: ({ accessToken, refreshToken, role, user }) => {
        if (accessToken) Cookies.set("accessToken", accessToken, { secure: true, sameSite: 'strict' });
        if (refreshToken) Cookies.set("refreshToken", refreshToken, { secure: true, sameSite: 'strict' });
        if (role) Cookies.set("role", role, { secure: true, sameSite: 'strict' });
        if (user) Cookies.set("user", JSON.stringify(user), { secure: true, sameSite: 'strict' });
        set({ accessToken, refreshToken, role, user });
    },

    setUser: (user) => {
        if (user) {
            Cookies.set("user", JSON.stringify(user), { secure: true, sameSite: 'strict' });
            set({ user });
        }
    },

    setRole: (role) => {
        if (role) {
            Cookies.set("role", role, { secure: true, sameSite: 'strict' });
            set({ role });
        }
    },

    clearTokens: () => {
        Cookies.remove("accessToken");
        Cookies.remove("refreshToken");
        Cookies.remove("role");
        Cookies.remove("user");
        set({ accessToken: null, refreshToken: null, role: null, user: null });
    }
}));